<template>
    <v-card class="pb-5">
        <v-card-title>Projektpartner</v-card-title>
        <PartnerCard v-for="partner in partners" :heading="partner.heading" :description="partner.description"
                     :contact="partner.contact" :logo="partner.logo" class="m-5" :key="partner.heading"/>
    </v-card>
</template>

<script>
    import PartnerCard from "@/components/home/PartnerCard";
    import partnersInfo from "@/settings/partners.settings";

    export default {
        name: "Partner",
        components: {
            PartnerCard
        },
        data: function () {
            return {
                partners: partnersInfo
            }
        }
    }
</script>

<style scoped>

</style>